import React, { useEffect, useMemo, useRef, useState } from "react";

export const HAT_TIP_FRAMES = [
  { src: "/assets/hat-tip/hat-tip-idle.png", delay: 0 },
  { src: "/assets/hat-tip/hat-tip-hand-up.png", delay: 80 },
  { src: "/assets/hat-tip/hat-tip-forward.png", delay: 180 },
  { src: "/assets/hat-tip/hat-tip-return.png", delay: 320 },
  { src: "/assets/hat-tip/hat-tip-active.png", delay: 450 },
];

const IDLE_FRAME = HAT_TIP_FRAMES[0].src;
const ACTIVE_FRAME = HAT_TIP_FRAMES[HAT_TIP_FRAMES.length - 1].src;

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const preloadHatTipFrames = () => {
  if (typeof Image === "undefined") return;

  HAT_TIP_FRAMES.forEach(({ src }) => {
    const image = new Image();
    image.src = src;
  });
};

const HatTipReaction = ({ active, count = 0, disabled, onToggle }) => {
  const [frameSrc, setFrameSrc] = useState(active ? ACTIVE_FRAME : IDLE_FRAME);
  const previousActiveRef = useRef(active);
  const timersRef = useRef([]);
  const reducedMotion = useMemo(prefersReducedMotion, []);

  useEffect(() => {
    preloadHatTipFrames();
  }, []);

  useEffect(() => {
    timersRef.current.forEach((timerId) => clearTimeout(timerId));
    timersRef.current = [];

    if (active && !previousActiveRef.current && !reducedMotion) {
      HAT_TIP_FRAMES.forEach(({ src, delay }) => {
        timersRef.current.push(setTimeout(() => setFrameSrc(src), delay));
      });
      timersRef.current.push(setTimeout(() => setFrameSrc(ACTIVE_FRAME), 500));
    } else {
      setFrameSrc(active ? ACTIVE_FRAME : IDLE_FRAME);
    }

    previousActiveRef.current = active;

    return () => {
      timersRef.current.forEach((timerId) => clearTimeout(timerId));
      timersRef.current = [];
    };
  }, [active, reducedMotion]);

  return (
    <button
      type="button"
      className={`hat-tip-button ${active ? "is-active" : ""}`}
      onClick={onToggle}
      disabled={disabled}
      aria-label={active ? "Remove Hat Tip" : "Give a Hat Tip"}
      aria-pressed={active}
    >
      <img src={frameSrc} alt="" aria-hidden="true" className="hat-tip-icon" />
      <span>Hat Tip</span>
      {count > 0 && <span className="hat-tip-count">{count}</span>}
    </button>
  );
};

export default HatTipReaction;
